import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Cookies from 'js-cookie';

//internationalization
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import global_es from './translations/es/global.json';


// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// Loading internationalization 
const lng = Cookies.get('IDIOMA_SESION') || 'es';
i18next.init({
  interpolation: { escapeValue: false },
  lng: lng,
  resources:{
    es: {
      global: global_es
    }
  }
})


const urlParams = new URLSearchParams(window.location.search);
const isMobile = urlParams.get('mobile') === 'true';

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App lng={lng} isMobile={isMobile}/>
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root_ibot')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
